<script lang="ts">
	import ContactSetting from "../../organisms/settings/ContactSetting.svelte";
</script>

<div class="flex">
	<div class="flex-1">
 		<ContactSetting/>
	</div>
</div>